// extracted by mini-css-extract-plugin
export var backlink = "Footer-module--backlink--d2385";
export var footer = "Footer-module--footer--8fb2c";